module.exports = __webpack_public_path__ + "img/footer-img.5b62786e.webp";